import ReactDOM from 'react-dom/client';
import { Suspense, lazy } from 'react';

import { isA1App } from '@shared/utils/platform/platformDetection';

import { bootstrap } from '@utils/bootstrap';
import { StaticRouter } from 'react-router-dom/server';
import '@shared/config/controller';
import { isMobileOnly } from 'react-device-detect';
import { BrowserRouter } from 'react-router-dom';
import { isA1 } from '@shared/matrix/const';
const App = lazy(() => import('./App'));
const MobileApp = lazy(() => import('./mobile'));

const DeviceDetect: React.FC = () => {
	console.timeEnd('[🧪Pref] React loaded');
	console.time('[🧪Pref] Splash loaded');
	return isMobileOnly || !isA1 ? (
		<StaticRouter
			future={{ v7_relativeSplatPath: true, v7_startTransition: true }}
			location={location.pathname}
		>
			<Suspense>
				<MobileApp />
			</Suspense>
		</StaticRouter>
	) : (
		<BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
			<Suspense>
				<App />
			</Suspense>
		</BrowserRouter>
	);
};

bootstrap();

// if (isAnniversary) document.body.classList.add('anniversary-theme');
// if (CountryUtils.isLasserBairam) document.body.classList.add('lasserBairam-theme');
// if (CountryUtils.isEaster) document.body.classList.add('easter-theme');
if (isA1App) {
	document.body.classList.add('default-theme-app');
} else {
	document.body.classList.add('default-theme');
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<DeviceDetect />);
